import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ListResultDTO } from 'src/app/helpers/listResult.interface';
import { environment } from 'src/environments/environment';

import { ContactDTO } from '../../models/contact.model';
import { ContactFilters } from './../../models/contact.model';

@Injectable({
  providedIn: "root"
})
export class LaravelContactService {


  constructor(private httpClient: HttpClient) { }

  private get ROUTES() {
    return {

      list: environment.baseUrl + "/api/contacts",
      show: environment.baseUrl + "/api/contact",
      store: environment.baseUrl + "/api/contact",
      destroy: environment.baseUrl + "/api/contact",

    };
  }

  public list(page: number,
    per_page: number,
    order: string,
    direction: string,
    filters: ContactFilters,
    includes?: string[]
  ): Observable<ListResultDTO<ContactDTO>> {
    let params = {};
    if (order) params["order"] = "" + order;
    if (direction) params["direction"] = "" + direction;
    if (includes) params["includes[]"] = includes;
    if (filters) {
      if (filters.search) params["search"] = "" + filters.search;
      if (filters.client) params["client_id"] = "" + filters.client.id;
  }
    if (per_page) {
      params["per_page"] = "" + per_page;
      if (page) params["page"] = "" + page;
      return this.httpClient.get<ListResultDTO<ContactDTO>>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      });
    } else {
      return this.httpClient.get<ContactDTO[]>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      }).pipe(
        map(results => {
          return {
            data: results,
            total: results.length
          };
        })
      );
    }
  }


  public getContactById(id: number): Observable<ContactDTO> {
    let params = { id: "" + id };
    return this.httpClient.get<ContactDTO>(this.ROUTES.show, {
      params: new HttpParams({
        fromObject: params
      })
    });

  }

  public upsert(contact: ContactDTO): Observable<ContactDTO> {
    if (contact.id) {
      return this.httpClient.put<ContactDTO>(`${this.ROUTES.store}`, { contact });
    } else {
      return this.httpClient.post<ContactDTO>(`${this.ROUTES.store}`, { contact });
    }
  }

  public delete(id: number): Observable<any> {
    let params = { id: "" + id };
    return this.httpClient.delete(this.ROUTES.destroy, {
      params: new HttpParams({
        fromObject: params
      })
    });
  }
}
